import { Sidebar } from './Sidebar';
import { UILabelsProvider } from '../../context/UILabelsContext';
import { useAuth } from '../../context/AuthContext';

export const DashboardLayout = ({ children }) => {
  const { tenant } = useAuth();
  return (
    <UILabelsProvider tenantId={tenant?.id} isPublic={false}>
    <div className="flex min-h-screen bg-[#F9F8F6]">
      <Sidebar />
      <main className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </main>
    </div>
    </UILabelsProvider>
  );
};
